module.exports = __webpack_public_path__ + "img/krisma-header.26372dae.jpg";